import React from "react";
import styles from "./Services.module.css";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import "./Services.css";
import "swiper/css";
import "swiper/css/pagination";
import { Link } from "react-router-dom";

const Services = () => {
  return (
    
    <div className={styles.main}>
      <Container>
        <div className={styles.cont}>
          <h3 className="h2_main text-center pb-2">EXPLORE</h3>
          <h2 className="h1_main text-center pb-5">OUR CATEGORIES</h2>
          <Row className="gy-4">
            <Col lg={3}>
              <Link
                style={{ textDecoration: "none" }}
                to="/shop/EP-Cube-Home-Energy-Storage"
              >
                <div className={styles.box}>
                  {/* <img alt="side " src="/images/category4.webp" /> */}
                  <img alt="side " src="/images/home-category4-new-hd.jpg" />
                  <div className={styles.contentCol}>
                    <h2 className="h2_main">
                      SOLAR & ENERGY STORAGE, SOLAR SYSTEMS
                    </h2>
                  </div>
                </div>
              </Link>
            </Col>
              <Col lg={3}>
              <Link
                style={{ textDecoration: "none" }}
                // to="/shop/Off-Grid-and-Home-Solar-Kits"
                // to="/shop/ECOFLOW-Solar-Kits"
                to="/shop/EG4-Batteries-&-Inverters"
              >
                <div className={styles.box}>
                  <img alt="side " src="/images/category3-new.png" />
                  <div className={styles.contentCol}>
                    {/* <h2 className="h2_main">SOLAR KITS</h2> */}
                    <h2 className="h2_main">EG4 Batteries & Inverters</h2>

                   
                    <p className="para_main">
                    EG4 SOLAR + BATTERY KITS AND ECOFLOW SOLAR KITS
                    </p>
                  </div>
                </div>
              </Link>
            </Col>
             <Col lg={3}>
              <Link
                style={{ textDecoration: "none" }}
                // to="/shop/EcoFlow-Delta-Battery-Generators"
                to="/shop/Ecoflow-Delta-Portable-Power-Stations"
              >
                <div className={styles.box}>
                  {/* <img alt="side " src="/images/category2.webp" /> */}
                  <img alt="side " src="/images/category2-new.png" />
                  <div className={styles.contentCol}>
                    <h2 className="h2_main">Portable Power Stations</h2>
                    {/* <p className="para_main">
                      ECOFLOW RIVER AND ECOFLOW DELTA LITHIUM LiFePO4 POWER
                      STATIONS/SOLAR GENERATORS
                    </p> */}
                    <p className="para_main">
                      ECOFLOW DELTA SERIES LITHIUM LiFePO4 POWER STATIONS
                    </p>
                  </div>
                </div>
              </Link>
            </Col>
            <Col lg={3}>
              <Link
                style={{ textDecoration: "none" }}
                // to="/shop/12V-Batteries-Trolling-and-RV"
                // to="/shop/12V-24V-36V-LiFePO4-Batteries-and-Chargers"
                to="/shop/Volthium-12V-Lithium-Batteries"
              >
                <div className={styles.box}>
                  {/* <img alt="side " src="/images/category1-march.png" /> */}
                  <img alt="side " src="/images/lithium-batteries-volthium-rackmount.jpg" />
                  <div className={styles.contentCol}>
                    <h2 className="h2_main">Lithium Batteries</h2>
                   
                    <p className="para_main">
                     {/* 12V, 24V, 36V AND 48V LITHIUM LiFePO4 BATTERIES BY VOLTHIUM, EG4 AND ECOFLOW */}
                     VOLTHIUM LiFePO4 RACKMOUNT AND 12V BATTERIES
                    </p>
                  </div>
                </div>
              </Link>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default Services;
